// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        this.querySelector(
          '.loading__spinner'
        ).classList.remove('hidden');

        /*
         * ------------------------------------------
         * PRODUCT FORM DATA
         * ------------------------------------------
         */

        const formData = new FormData(this.form);

        const mainVariantId = Number(
          formData.get('id')
        );

        const quantity =
          Number(formData.get('quantity')) || 1;

        /*
         * ------------------------------------------
         * MAIN PRODUCT
         * ------------------------------------------
         */

        const mainItem = {
          id: mainVariantId,
          quantity: quantity
        };

        /*
         * ------------------------------------------
         * PRODUCT PROPERTIES
         * ------------------------------------------
         */

        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propertyName = key
              .replace('properties[', '')
              .replace(']', '');

            if (value !== '') {
              properties[propertyName] = value;
            }
          }
        }

        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties;
        }

        /*
         * ------------------------------------------
         * SELLING PLAN
         * ------------------------------------------
         */

        const sellingPlan = formData.get(
          'selling_plan'
        );

        if (sellingPlan) {
          mainItem.selling_plan =
            Number(sellingPlan);
        }

        /*
         * ------------------------------------------
         * CART ITEMS
         * ------------------------------------------
         *
         * First item = main product
         *
         */

        const items = [mainItem];

        /*
         * ------------------------------------------
         * ORIGINAL BRAND BOX
         * ------------------------------------------
         *
         * Checkbox comes from main-product.liquid
         *
         * data-original-box-checkbox
         * data-original-box-option
         * data-box-variant-id
         *
         */

        const boxCheckbox =
          document.querySelector(
            '[data-original-box-checkbox]'
          );

        const boxOption =
          document.querySelector(
            '[data-original-box-option]'
          );

        if (
          boxCheckbox &&
          boxCheckbox.checked &&
          boxOption
        ) {
          const boxVariantId = Number(
            boxOption.dataset.boxVariantId
          );

          /*
           * Add Original Brand Box as
           * separate Shopify product
           */

          if (boxVariantId) {
            items.push({
              id: boxVariantId,
              quantity: quantity
            });
          }
        }

        /*
         * ------------------------------------------
         * SHOPIFY AJAX CART CONFIG
         * ------------------------------------------
         */

        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        config.headers[
          'Content-Type'
        ] = 'application/json';

        /*
         * ------------------------------------------
         * CART DRAWER SECTIONS
         * ------------------------------------------
         */

        const cartSections =
          this.cart
            ? this.cart
                .getSectionsToRender()
                .map((section) => section.id)
            : [];

        /*
         * ------------------------------------------
         * REQUEST BODY
         * ------------------------------------------
         */

        const requestBody = {
          items: items
        };

        if (this.cart) {
          requestBody.sections =
            cartSections;

          requestBody.sections_url =
            window.location.pathname;

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body =
          JSON.stringify(requestBody);

        /*
         * ------------------------------------------
         * ADD TO CART
         * ------------------------------------------
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => {
            return response.json();
          })

          .then((response) => {

            /*
             * --------------------------------------
             * SHOPIFY ERROR
             * --------------------------------------
             */

            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    mainVariantId,

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message
                }
              );

              this.handleErrorMessage(
                response.description ||
                  response.message
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
             * --------------------------------------
             * NO CART DRAWER
             * --------------------------------------
             */

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            /*
             * --------------------------------------
             * CART UPDATE EVENT
             * --------------------------------------
             */

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',

                  productVariantId:
                    mainVariantId,

                  cartData: response
                }
              ).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            /*
             * --------------------------------------
             * QUICK ADD MODAL
             * --------------------------------------
             */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {

              document.body.addEventListener(
                'modalClosed',
                () => {

                  setTimeout(() => {

                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {

                        this.cart.renderContents(
                          response
                        );

                      }
                    );

                  });

                },
                {
                  once: true
                }
              );

              quickAddModal.hide(true);

            } else {

              /*
               * ------------------------------------
               * NORMAL CART DRAWER
               * ------------------------------------
               */

              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {

                  this.cart.renderContents(
                    response
                  );

                }
              );

            }
          })

          /*
           * ----------------------------------------
           * FETCH ERROR
           * ----------------------------------------
           */

          .catch((e) => {

            console.error(
              'Product form error:',
              e
            );

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );

          })

          /*
           * ----------------------------------------
           * FINALLY
           * ----------------------------------------
           */

          .finally(() => {

            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            this.querySelector(
              '.loading__spinner'
            ).classList.add('hidden');

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );

          });
      }

      /*
       * ------------------------------------------
       * ERROR MESSAGE
       * ------------------------------------------
       */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      /*
       * ------------------------------------------
       * TOGGLE SUBMIT BUTTON
       * ------------------------------------------
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;

        }
      }

      /*
       * ------------------------------------------
       * MAIN VARIANT ID
       * ------------------------------------------
       */

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}